import { DateTime } from "luxon";

export const workshops = (state = {data: [], total: 0}, action) => {
  switch (action.type) {
    case 'WORKSHOPS_FETCHED':
      return {
        data: action.data,
        total: action.total
      }

    default:
      return state;
  }
}

export const workshop = (state = {}, action) => {
  switch (action.type) {
    case 'WORKSHOP_FETCHED':
      return {
        ...state,
        ...action.data
      }

    case 'WORKSHOP_REMOVED': {
      const removedId = action.data?.id

      if (!removedId) return state

      return {
        ...state,
        tree: {
          ...state.tree,
          children: state.tree?.children?.filter(
            w => w.uuid !== removedId
          ) || [],
          totalChildren: (state.tree?.totalChildren || 1) - 1
        }
      }
    }
    
    case 'WORKSHOP_ADDED': {
      const { uuid, name, parentId } = action.data || {}
      if (!uuid || !state.tree) return state

      const node = { uuid, name, totalChildren: 0, children: [] }
      const insert = (tree, parentId) => {
        if (parentId == null || tree.uuid === parentId) {
          return {
            ...tree,
            children: [node, ...(tree.children || [])],
            totalChildren: (tree.totalChildren || 0) + 1
          }
        }
        return {
          ...tree,
          children: (tree.children || []).map(child => insert(child, parentId))
        }
      }

      return { ...state, tree: insert(state.tree, parentId) }
    }

  case 'WORKSHOP_RENAMED': {
    const { id, newName } = action.data || {}
    if (!id || !newName) return state
  
    return {
        ...state,
        tree: {
          ...state.tree,
          children: state.tree.children.map(w =>
            w.uuid === id ? { ...w, name: newName } : w
          )
        }
      }
   }

    case 'FETCHING_WORKSHOP_FAILED':
      return {
        ...state,
        workshopId: action.data.workshopId
      }
    case 'WORKSHOP_USERS_FETCHED':
      return {
        ...state,
        users: action.data.users,
        users_workshopId: action.data.workshopId,
        numberOfUsers: action.data.number
      }
    case 'FETCHING_WORKSHOP_USERS_FAILED':
      return {
        ...state,
        users_workshopId: action.data.workshopId,
      }
    case 'FLUSH_WORKSHOP':
      return {}
    default:
      return state
  }
}